import React, { useState, useEffect } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toastOption
} from "../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { fetchPrograms } from "../../../MasterData/_redux/program/programAction";
import AddIcon from "@material-ui/icons/Add";

export default function ProgramModal({ show, onHide, selectedRow }) {
  const [queryParams, setQueryParams] = useState({
    filter: {
      name: ""
    },
    pageNumber: 1,
    pageSize: 5
  });

  const { currentState } = useSelector(
    state => ({ currentState: state.programs }),
    shallowEqual
  );

  const { totalCount, entities, listLoading, error } = currentState;
  if (error) {
    toast.error(error, toastOption);
  }

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(fetchPrograms(queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, dispatch]);

  const columns = [
    {
      dataField: "fund_type.name",
      text: "Jenis Dana",
      sort: true
    },
    {
      dataField: "name",
      text: "Nama Program",
      sort: true
      // sortCaret: sortCaret,
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: (cell, row) => {
        return (
          <>
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Pilih</Tooltip>}
            >
              <a
                className="btn btn-icon btn-light btn-hover-success btn-sm mx-3"
                onClick={() => selectedRow(row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-success">
                  <AddIcon />
                </span>
              </a>
            </OverlayTrigger>
          </>
        );
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px"
      }
    }
  ];

  const sizePerPageList = [
    { text: "5", value: 5 },
    { text: "10", value: 10 },
    { text: "15", value: 15 }
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header>
        <h4>Pilih Program</h4>
      </Modal.Header>
      <Modal.Body>
        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({ paginationProps, paginationTableProps }) => {
            return (
              <Pagination
                isLoading={listLoading}
                paginationProps={paginationProps}
              >
                <BootstrapTable
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  bordered={false}
                  remote
                  keyField="uuid"
                  data={entities === null ? [] : entities}
                  columns={columns}
                  onTableChange={getHandlerTableChange(setQueryParams)}
                  {...paginationTableProps}
                >
                  <PleaseWaitMessage entities={entities} />
                  <NoRecordsFoundMessage entities={entities} />
                </BootstrapTable>
              </Pagination>
            );
          }}
        </PaginationProvider>
      </Modal.Body>
    </Modal>
  );
}
